import {
  GET_USERS_SUCCESS,
  GET_USERS_FAIL,
  ADD_USER_SUCCESS,
  ADD_USER_FAIL,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  GET_USER_PROFILE_SUCCESS,
  GET_USER_PROFILE_FAIL,
  NEXT_PAGE,
  PREVIOUS_PAGE,
  FIRST_PAGE,
  LAST_PAGE,
  RESET_CREATE_USER_STATE,
  RESET_UPDATE_USER_STATE,
  RESET_DELETE_USER_STATE,
} from "./actionTypes"

const INIT_STATE = {
  users: [],
  userProfile: {},
  error: {},
  currentPageIndex: 1,
  totalPages: 0,
  deleteSuccess: false,
  deleteError: null,
  createUserSuccess: false,
  createUserError: null,
  updateUserSuccess: false,
  updateUserError: null,
}

const contacts = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload,
      }

    case GET_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_USER_SUCCESS:
      return {
        ...state,
        users: [...state.users, action.payload],
        createUserSuccess: true,  // Marca sucesso na criação
        createUserError: null,    // Limpa erro na criação
      };

    case ADD_USER_FAIL:
      return {
        ...state,
        createUserSuccess: false,  // Marca falha na criação
        createUserError: action.payload,  // Define erro
      };

    case RESET_CREATE_USER_STATE:
      return {
        ...state,
        createUserSuccess: false,  // Reseta sucesso
        createUserError: null,     // Reseta erro
      };

    case GET_USER_PROFILE_SUCCESS:
      return {
        ...state,
        userProfile: action.payload,
      }

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        updateUserSuccess: true,
        updateUserError: null

      }

    case UPDATE_USER_FAIL:
      return {
        ...state,
        updateUserSuccess: false,  // Marca falha na criação
        updateUserError: action.payload,
      }

      case RESET_UPDATE_USER_STATE:
      return {
        ...state,
        updateUserSuccess: false,  // Reseta sucesso
        updateUserError: null,     // Reseta erro
      };

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.filter(
          user => user?.Id?.toString() !== action?.payload?.Id?.toString()
        ),
        deleteSuccess: true,  // Marca sucesso
        deleteError: null,
      }

    case DELETE_USER_FAIL:
      return {
        ...state,
        deleteSuccess: false,
        deleteError: action.payload,
      };

    case RESET_DELETE_USER_STATE:
      return {
        ...state,
        deleteSuccess: false,
        deleteError: null,
      };

    case GET_USER_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }







    case NEXT_PAGE:
      return {
        ...state,
        currentPageIndex: state.currentPageIndex + 1,
      };

    case PREVIOUS_PAGE:
      return {
        ...state,
        currentPageIndex: state.currentPageIndex - 1,
      };

    case FIRST_PAGE:
      return {
        ...state,
        currentPageIndex: 1,
      };

    case LAST_PAGE:
      return {
        ...state,
        currentPageIndex: state.totalPages,
      };








    default:
      return state
  }
}

export default contacts
